<template>
  <div class="vimeo-container">
    <iframe
      :src="videoSrc"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
      allowfullscreen
      title="Guide til opgaveoversigt designeren">
    </iframe>
  </div>
</template>

<script>
export default {
  props: {
    videoId: {
      type: String,
      required: true,
      default: 1056171188
    }
  },
  computed: {
    videoSrc () {
      return `https://player.vimeo.com/video/${this.videoId}?badge=0&autopause=0&player_id=0&app_id=58479`
    }
  }
}
</script>

<style scoped>
.vimeo-container {
  position: relative;
  padding-top: 75%;
  height: 0;
  overflow: hidden;
}

.vimeo-container iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.to-guide__header {
  padding-top: 1rem;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// TaskOverviewSettingsGuide.vue?7203882d